import { render } from "./PremiumCalculator.vue?vue&type=template&id=a2e4f5a8&scoped=true"
import script from "./PremiumCalculator.vue?vue&type=script&lang=js"
export * from "./PremiumCalculator.vue?vue&type=script&lang=js"

import "./PremiumCalculator.vue?vue&type=style&index=0&id=a2e4f5a8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2e4f5a8"]])

export default __exports__